import React, { useState, useEffect } from 'react';
import api from '../api/axios';

const GameManager = () => {
    const [games, setGames] = useState([]);
    const [newGameName, setNewGameName] = useState('');
    const [newGameCategory, setNewGameCategory] = useState('Board Game');
    const [isLoading, setIsLoading] = useState(true);

    const fetchGames = async () => {
        try {
            // Fetch ALL games for the admin, including inactive ones
            const response = await api.get('/games?all=true'); 
            setGames(response.data);
        } catch (err) {
            console.error("Failed to fetch games", err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchGames();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleAddGame = async (e) => {
        e.preventDefault();
        if (!newGameName.trim()) return;

        try {
            await api.post('/games', { name: newGameName, category: newGameCategory });
            setNewGameName(''); 
            fetchGames(); 
        } catch (err) {
            alert(err.response?.data?.error || "Failed to add game");
        }
    };

    const handleToggleGame = async (id) => {
        try {
            await api.patch(`/games/${id}/toggle`);
            fetchGames(); 
        } catch (err) {
            console.error("Failed to toggle game", err);
        }
    };

    return (
        <div className="space-y-6 animate-in fade-in">
            {/* ADD NEW GAME FORM */}
            <div className="bg-white p-6 rounded-3xl border border-gray-200 shadow-sm">
                <h2 className="text-xl font-black text-gray-800 mb-4">Add New Game</h2>
                <form onSubmit={handleAddGame} className="flex flex-col md:flex-row gap-4">
                    <input 
                        type="text" 
                        placeholder="e.g. Magic: The Gathering" 
                        value={newGameName} 
                        onChange={(e) => setNewGameName(e.target.value)}
                        className="flex-1 bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 font-bold focus:border-blue-500 outline-none"
                        required
                    />
                    <select 
                        value={newGameCategory} 
                        onChange={(e) => setNewGameCategory(e.target.value)}
                        className="bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 font-bold focus:border-blue-500 outline-none"
                    >
                        <option value="Board Game">Board Game</option>
                        <option value="Card Game">Card Game</option>
                        <option value="Tabletop">Tabletop</option>
                        <option value="Video Game">Video Game</option>
                    </select>
                    <button 
                        type="submit" 
                        className="bg-blue-600 hover:bg-blue-700 text-white font-black px-8 py-3 rounded-xl transition-all shadow-lg active:scale-95"
                    >
                        Add Game ➕
                    </button>
                </form>
            </div>

            {/* GAMES DATABASE LIST */}
            <div className="bg-white p-6 rounded-3xl border border-gray-200 shadow-sm">
                <h2 className="text-xl font-black text-gray-800 mb-4">Games Database</h2>
                
                {isLoading ? (
                    <div className="text-gray-400 font-bold animate-pulse">Loading database...</div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {games.map(game => (
                            <div key={game._id} className="flex items-center justify-between p-4 border-2 border-gray-100 rounded-2xl hover:border-blue-100 transition-colors">
                                <div>
                                    <h3 className="font-black text-gray-900 text-lg">{game.name}</h3>
                                    <span className="text-xs font-bold text-gray-400 uppercase tracking-wider">{game.category}</span>
                                </div>
                                <button 
                                    onClick={() => handleToggleGame(game._id)}
                                    className={`px-4 py-2 rounded-lg font-bold text-sm transition-all ${
                                        game.isActive 
                                        ? 'bg-green-100 text-green-700 hover:bg-green-200' 
                                        : 'bg-red-100 text-red-700 hover:bg-red-200'
                                    }`}
                                >
                                    {game.isActive ? 'Active ✅' : 'Hidden ❌'}
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default GameManager;